import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExcRestService} from 'exc-rest-v2';
import {IExgTab} from 'exc-tab-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExcSecurityService} from 'exc-security-v2';
import {ApplicationService} from '../services/application.service';
import {DataService} from '../services/data.service';
import {ILeistungserfassungSummaryData} from '../misc/interfaces/ILeistungserfassungSummaryData';

@Component({
  selector: 'app-leistungserfassung-checkview',
  templateUrl: './leistungserfassung-checkview.component.html',
  styles: [
  ]
})
export class LeistungserfassungCheckviewComponent extends ExcTranslation implements OnInit, IExgTab {
  @Input()
  Data: { leID: string, leNr: string, leName: string } = {leID: '', leNr: '', leName: ''};
  @Input()
  set inputTabinstance(value: any) {
    this.tabinstance = value;
  }

  tabinstance: any;

  ServiceRecordSummary: ILeistungserfassungSummaryData | any = this.dataSvc.Leistungserfassung.Summary.Get();

  commentary: any[] = [];
  commentaryDate: any[] = [];

  constructor(
    private excRestService: ExcRestService,
    private modal: ExgModalService,
    public excSecurity: ExcSecurityService,
    public appSvc: ApplicationService,
    private dataSvc: DataService
  ) {
    super();
  }

  ngOnInit(): void {
    this.ServiceRecordSummary = this.dataSvc.Leistungserfassung.Summary.Get(this.Data?.leID);
    this.loadCommentaryList();
  }

  loadData(): void {
    this.ServiceRecordSummary?.LoadSummary();
    this.loadCommentaryList();
  }

  openAttachments(): void {
    this.modal.show('ModalAttachmentViewerComponent', {
      entityName: 'Leistungserfassung',
      extensionName: 'Attachment',
      ID: this.Data.leID,
      isDisabled: false
    }).subscribe();
  }

  openCommentaryModal = (): void => {
    this.modal.show('CommentaryModalComponent', {checkview: this}).subscribe(() => {
      this.loadCommentaryList();
    });
  }

  loadCommentaryList = (): void => {
    this.excRestService
      .get(
        this.excRestService.computeUrl('LeistungserfassungKommentarR_List', {ID: this.Data.leID}),
        {}
      )
      .subscribe((response: any) => {
        if (response && response.success) {
          this.loadCommentaries(response.data.Commentary, response.data.CommentaryDate);
        }
      });
  }

  /*für CommentaryModal, ist nicht unused*/
  commentaryCreate = (obj: { commText: string; commTyp: number }): void => {
    this.excRestService
      .post(
        this.excRestService.computeUrl('LeistungserfassungKommentarC', {ID: this.Data.leID}),
        {ID: this.Data.leID, Message: obj.commText}
      )
      .subscribe((response: any) => {
        if (response && response.success) {
          this.loadCommentaries(response.data.Commentary, response.data.CommentaryDate);
        }
      });
  }

  loadCommentaries = (Commentary: any[], CommentaryDate: any[]): void => {
    this.commentaryDate = CommentaryDate;
    this.commentary = Commentary;
  }

  showHistory(): void {
    this.appSvc.History.OpenModal(this.ServiceRecordSummary?.historyTable?.data);
  }

  canFinish(): boolean {
    return !!this.ServiceRecordSummary?.serviceRecordDetails?.data?.isOwner
      && (this.ServiceRecordSummary?.serviceRecordDetails?.data?.leState === 1 || this.ServiceRecordSummary?.serviceRecordDetails?.data?.leState === 2);
  }

  isAuditor(): boolean {
    return this.ServiceRecordSummary?.serviceRecordDetails?.data?.lePicker === this.excSecurity.UserLogin
      // && !this.ServiceRecordSummary?.serviceRecordDetails?.data?.isOwner // TODO WIP JMA
      && this.ServiceRecordSummary?.serviceRecordDetails?.data?.leState === 5;
  }

  canAudit(): boolean {
    return this.isAuditor(); // && this.excSecurity.isFeatured('LVFREIGABE'); TODO
  }

  canPick(): boolean {
    return this.ServiceRecordSummary?.serviceRecordDetails?.data?.lePicker !== this.excSecurity.UserLogin
      // && this.ServiceRecordSummary?.serviceRecordDetails?.data?.leOwner !== this.excSecurity.UserLogin // TODO WIP JMA
      && (this.ServiceRecordSummary?.serviceRecordDetails?.data?.leState === 3
        || this.ServiceRecordSummary?.serviceRecordDetails?.data?.leState === 4
        || this.ServiceRecordSummary?.serviceRecordDetails?.data?.leState === 5);
  }

  pick(): void {
    if (!this.ServiceRecordSummary?.serviceRecordDetails?.data?.lePicker) {
      this.updatePicker();
      return;
    }
    this.modal.showSimple(
      this.getRessource('PickConfirmHeader'),
      this.getRessource('PickConfirmContent', {picker: this.ServiceRecordSummary?.serviceRecordDetails?.data?.lePickU}),
      true,
      true,
      this.getRessource('PickConfirm'),
      this.getGlobal('Cancel')
    ).subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.updatePicker();
      }
    });
  }

  updatePicker(): void {
    this.excRestService.put(
      this.excRestService.computeUrl('LeistungserfassungUpdatePicker', {}),
      {leID: this.Data.leID, login: this.excSecurity.UserLogin,UPT: this.ServiceRecordSummary?.serviceRecordDetails?.data?.leUPT},
      {}
    ).subscribe(() => {
      this.loadData();
    });
  }

  canRename(): boolean {
    return !!this.ServiceRecordSummary?.serviceRecordDetails?.data?.isOwner
      && this.ServiceRecordSummary?.serviceRecordDetails?.data?.leState !== 6
      && this.ServiceRecordSummary?.serviceRecordDetails?.data?.leState !== 10;
  }

  rename(): void {
    this.modal.show('ModalLeistungNameComponent', {
      headerText: this.getRessource('RenameHeader'),
      caption: this.getRessource('RenameCaption'),
      buttonText: this.getGlobal('Save'),
      name: this.ServiceRecordSummary?.serviceRecordDetails?.data?.leName || this.Data.leName
    }).subscribe((response: any) => {
      if (response) {
        this.updateName(response.name);
      }
    });
  }

  updateName(name: string): void {
    this.excRestService.put(
      this.excRestService.computeUrl('LeistungserfassungUpdateName', {}),
      {leID: this.Data.leID, leName: name, UPT: this.ServiceRecordSummary?.serviceRecordDetails?.data?.leUPT},
      {}
    ).subscribe((response: any) => {
      if (response?.success) {
        this.Data.leName = name;
      } else {
        this.modal.showToast(
          this.getRessource('RenameFailed'),
          'md-toast',
          'fas fa-exclamation'
        );
      }
      this.loadData();
    });
  }

  generateReport(): void {
    if (this.ServiceRecordSummary?.positionList?.data?.length === 0) {
      this.modal.showToast(
        this.getRessource('NoServiceRecorded'),
        'md-toast',
        'fas fa-exclamation'
      );
      return;
    }
    this.excRestService.get(
      this.excRestService.computeUrl('LeistungserfassungR_Report', {leID: this.Data.leID}),
      {export: true}
    ).subscribe();
  }

  isPicker(): boolean {
    return this.ServiceRecordSummary?.serviceRecordDetails?.data?.lePicker === this.excSecurity.UserLogin;
  }

  isEditingAllowed(lstg?: any): boolean {
    const isUserAllowed = lstg
      ? lstg.lstgOwner === this.excSecurity.UserLogin || !!this.ServiceRecordSummary?.serviceRecordDetails?.data?.isOwner
      : !!this.ServiceRecordSummary?.serviceRecordDetails?.data?.isOwner;

    return isUserAllowed
      && (this.ServiceRecordSummary?.serviceRecordDetails?.data?.leState === 1 || this.ServiceRecordSummary?.serviceRecordDetails?.data?.leState === 2)
      || this.isPicker() && this.ServiceRecordSummary?.serviceRecordDetails?.data?.leState === 5;
  }

  managePosition(lstg?: any): void {
    this.modal.show('ModalLeistungPositionComponent', {
      leID: this.Data.leID,
      priceList: this.ServiceRecordSummary?.priceList?.data,
      position: lstg,
      isOwner: !!this.ServiceRecordSummary?.serviceRecordDetails?.data?.isOwner
    }).subscribe((response: any) => {
      if (response) {
        this.loadData();
      }
    });
  }

  deletePosition(lstg: any): void {
    if (lstg.lstgOwner === this.excSecurity.UserLogin) {
      this.modal.showSimple(
        this.getRessource('DeletePositionHeader'),
        this.getRessource('DeletePositionDescription'),
        true,
        true,
        this.getGlobal('Delete'),
        this.getGlobal('Cancel')
      ).subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.removePosition(lstg);
        }
      });
      return;
    }
    this.modal.show('ModalLeistungStateChangeComponent', {
      leID: this.Data.leID,
      relation: JSON.stringify(lstg),
      commentRequired: true,
      headerText: this.getRessource('DeletePositionHeader'),
      description: this.getRessource('DeletePositionDescriptionRequired', {entry: lstg.lstgDescription})
    }).subscribe((response: any) => {
      if (response) {
        this.removePosition(lstg, response.comment);
      }
    });
  }

  removePosition(lstg: any, reason?: string): void {
    this.excRestService.delete(
      this.excRestService.computeUrl('LeistungserfassungLeistungDelete', {}),
      {
        lstgID: lstg.lstgID,
        leID: lstg.lstg_leID,
        UPT: lstg.lstgUPT,
        lstgChangedReason: reason
      },
      {}
    ).subscribe(() => {
      this.loadData();
    });
  }

  finishTarget(): number {
    return Number(this.getRessource('ServiceRecordNextState.' + this.ServiceRecordSummary?.serviceRecordDetails?.data?.leState));
  }

  changeState(target: number): void {
    if (this.ServiceRecordSummary?.positionList?.data?.length === 0) {
      this.modal.showToast(
        this.getRessource('NoServiceRecorded'),
        'md-toast',
        'fas fa-exclamation'
      );
      return;
    }
    const commentRequired = target === 2;
    this.modal.show('ModalLeistungStateChangeComponent', {
      leID: this.Data.leID,
      headerText: this.getRessource('StateAction.' + target),
      description: commentRequired
        ? this.getRessource('RejectCommentDescriptionRequired')
        : this.getRessource('CommentDescription'),
        commentRequired
    }).subscribe((response: any) => {
      if (response) {
        this.updateState(target, response);
      }
    });
  }

  updateState(target: number, addData?: any): void {
    const updobj: any = {leID: this.Data.leID, State: target, UPT: this.ServiceRecordSummary?.serviceRecordDetails?.data?.leUPT};
    if (target === 10 && addData) {
      const billing = new Date(addData.billingDate);
      updobj.leAbrechnungsMonat = billing.getMonth() + 1;
      updobj.leAbrechnungsJahr = billing.getFullYear();
    }
    this.excRestService.put(
      this.excRestService.computeUrl('LeistungserfassungUpdate', {}),
      updobj,
      {}
    ).subscribe(() => {
      this.loadData();
    });
  }

  rowTotal(lstg: any): number {
    if (lstg.lstgAmount === undefined || lstg.lstgAmount === null){
      return lstg.lstgPrice;
    }

    return lstg.lstgAmount * lstg.lstgPrice;
  }

  sumTotal(): number {
    if (this.ServiceRecordSummary?.serviceRecordDetails?.isEmpty) {
      return 0;
    }
    return (this.ServiceRecordSummary?.serviceRecordDetails?.data?.leHonorarleistungSum || 0)
      + (this.ServiceRecordSummary?.serviceRecordDetails?.data?.leFahrtkostenSum || 0)
      + (this.ServiceRecordSummary?.serviceRecordDetails?.data?.leSonstigeKostenSum || 0)
      + (this.ServiceRecordSummary?.serviceRecordDetails?.data?.leAuslagenSum || 0);
  }

}
